import styled from 'styled-components';
import { colors } from '@keen.io/colors';

export const Container = styled.div`
  padding: 5px 0;
  min-width: 145px;
`;

export const DeleteDashboard = styled.span`
  color: ${colors.red[500]};
`;
